import { render, staticRenderFns } from "./about-us.vue?vue&type=template&id=30675a1b&"
import script from "./about-us.vue?vue&type=script&lang=ts&"
export * from "./about-us.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports